import React, { useState } from 'react';
import './UserQuestions.css';
import { FiChevronDown } from 'react-icons/fi';

// Data for questions and answers
const faqData = [
  {
    question: 'How do I register on your website?',
    answer: 'To register, click the "Sign Up" button in the top right corner, fill in the required fields and confirm your email address.'
  },
  {
    question: 'What payment methods do you accept?',
    answer: 'We accept online payments through the Wayforpay service. You can pay with cards from any bank, as well as through popular mobile wallets and services such as Google Pay and Apple Pay. After payment, the number of services according to your chosen plan will appear in your profile wallet balance.'
  },
  {
    question: 'Can I cancel my order after placing it?',
    answer: 'If you have already paid but have not yet used the plan and have not created any greeting cards or greeting text ideas — we can cancel the order and refund your money. If you have already started using the plan, then refunds are not provided. But you can fully use all the plan features and contact our technical support — we are always open to feedback and ready to seek compromise solutions to make the service better, results more accurate, and clients more satisfied.'
  },
  {
    question: 'How can I track my service balance?',
    answer: 'In the wallet section of your profile, you can view the available number of greeting card creations and text ideas, available number of edits, active discount for further greeting card creation after the plan allocation ends. If you topped up your balance not for plan payment, but for individual greeting card creation payments, it will also be displayed in the wallet. Also, if your friends to whom you sent referral links made a plan purchase, then 10% of its cost will also be transferred to your balance for individual greeting card creation.'
  },
  {
    question: 'Do you provide customer support?',
    answer: 'Yes, we care about the convenience of our users. All inquiries are handled by our Telegram bot: there you can find answers to common questions or leave a request for a manager. The manager will help with any technical questions, situations with plans or payments, and will also advise on how to better use the service. If problems arise or you are dissatisfied with the result, we always look for individual solutions and try to find the most convenient option for you.'
  }
];

const UserQuestions = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  // Function for toggling active element
  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="faq-section">
      <h2 className="faq-title">Frequently Asked Questions</h2>
      <div className="accordion-container">
        {faqData.map((item, index) => (
          <div key={index} className="accordion-item">
            <button className="accordion-question" onClick={() => toggleAccordion(index)}>
              <span>{item.question}</span>
              <FiChevronDown className={`accordion-icon ${activeIndex === index ? 'active' : ''}`} />
            </button>
            <div className={`accordion-answer ${activeIndex === index ? 'active' : ''}`}>
              <p>{item.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default UserQuestions;